export enum RightVideoId {
  onboarding = 1236,
}

/** The locked game a dialog was opened for, shown as a header above the unlock copy. */
export type LockedGameSummary = {
  name: string
  artist?: string
  iconUrl?: string
}

export interface LockedFeature {
  id: LockedFeatureId
  titleTranslationKey: string
  // Overrides the dialog title ("Upgrade your plan to unlock this feature").
  dialogTitleTranslationKey?: string
  // Overrides the closing call-to-action copy. May contain an `<email>` tag, rendered as a mailto link.
  ctaTranslationKey?: string
  // Overrides where the Contact button goes.
  contactHref?: string
  content: {
    leftTranslationKey: string
    rightUrl?: string | string[]
    rightVideoId?: RightVideoId
  }
}

export enum LockedFeatureId {
  Empty = 'Empty',
  FollowedGames = 'FollowedGames',
  FtueVideos = 'FtueVideos',
  GameCompetitors = 'GameCompetitors',
  GameFeatureIdeas = 'GameFeatureIdeas',
  GameImplementations = 'GameImplementations',
  GameUpdateImpacts = 'GameUpdateImpacts',
  GameVisuals = 'GameVisuals',
  MarketExplorer = 'MarketExplorer',
  MarketShare = 'MarketShare',
  SoftLaunch = 'SoftLaunch',
  NewGamePublished = 'NewGamePublished',
  LiveEventsTracker = 'LiveEventsTracker',
  ImplementationExamples = 'ImplementationExamples',
  MarketTrends = 'MarketTrends',
  Motivations = 'Motivations',
  CompareGames = 'CompareGames',
  GameUnlock = 'GameUnlock',
  GenreEssentials = 'GenreEssentials',
  GameFeatureFacts = 'GameFeatureFacts',
  DataExport = 'DataExport',
  CompareMotivationTab = 'CompareMotivationTab',
  AIAnalyst = 'AIAnalyst',
  LiveEventAnalytics = 'LiveEventAnalytics',
  LiveEventsGameUnlock = 'LiveEventsGameUnlock',
}
